//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='serverisnotavailable-panel-wrapper'>
    <div class="serverisnotavailable-panel">
      <div class='serverisnotavailable-header'>
        <span class='serverisnotavailable-app-title'>{{appSettings.appName}}</span>
        <!--span class='serverisnotavailable-text-title'>{{i18n.serverIsNotAvailable.title}}</span-->
        <!--span class='serverisnotavailable-text'>{{i18n.serverIsNotAvailable.text}} {{appSettings.server.host}}</span-->
        <span class='serverisnotavailable-text'>Нет связи с сервером приложения</span>
      </div>
      <Button type="primary" size="large" class="serverisnotavailable-try-recconect-button no-circle" @click="returnToWelcomePage">{{i18n.serverIsNotAvailable.tryReconnectButtonText}}</Button>
      <!--Button type="primary" size="large" class="serverisnotavailable-try-recconect-button no-circle" @click="tryToConnectToServer">{{i18n.serverIsNotAvailable.tryReconnectButtonText}}</Button-->
      <!--Button type="ghost" size="large" class="serverisnotavailable-try-recconect-button" @click="returnToWelcomePage">Вернуться на главную страницу</Button-->
      <!--div v-if='activeUser != null'>
        <span class='serverisnotavailable-logout-text' v-html='i18n.serverIsNotAvailable.logoutText'></span>
        <Button type="ghost" class="no-circle" @click="appStateServerConnectedSet(false)">{{i18n.login.signout}}</Button>
      </div-->
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

// import http from 'axios'

export default {
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n',
      'appState',
      'activeUser'
    ])
  },
  methods: {
    ...mapMutations([
      'appStateServerConnectedSet',
      'serverHostSet'
    ]),
    ...mapActions([
      'appStateLastWorkingRouteGetAndUnset'
    ]),
    returnToWelcomePage () {
      // localStorage.removeItem('BMSClientHost')
      // this.serverHostSet(null)
      this.$router.push('/')
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
#app .serverisnotavailable-panel-wrapper {
  height: 100%;
  padding-top: 15vh;
  padding-left: 32vw;
  background-color: #6070dd;
  background: url('/static/welcome-background-vsezdes-2.jpg') no-repeat center;
  background-size: cover;
  background-position: center;
}
#app .serverisnotavailable-panel {
  width: 36vw;
  padding: 20px 20px 30px 20px;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  background: rgba(255,255,255,1.0);
  border-radius: 20px;
  text-align: center;
}

/*****************************************************/

@media screen and (max-height: 550px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-top: 7vh;
  }
}
@media screen and (max-height: 450px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-top: 1vh;
  }
}

@media screen and (max-width: 1400px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-left: 26vw;
  }
  #app .serverisnotavailable-panel {
    width: 48vw;
  }
}
@media screen and (max-width: 1200px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-left: 26vw;
  }
  #app .serverisnotavailable-panel {
    width: 48vw;
  }
}
@media screen and (max-width: 992px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-left: 20vw;
  }
  #app .serverisnotavailable-panel {
    width: 60vw;
  }
}
@media screen and (max-width: 768px) {
  #app .serverisnotavailable-panel-wrapper {
    padding-left: 15vw;
  }
  #app .serverisnotavailable-panel {
    width: 70vw;
  }
}

/*****************************************************/

#app .serverisnotavailable-header {
  /*margin-bottom: 20px;*/
  color: rgba(128,128,128,1.0);
  /*background: rgba(255,255,255,.0);*/
}
#app .serverisnotavailable-app-title {
  display: block;
  font-family: 'Lobster', cursive;
  font-size: 40px;
  text-align: center;
  padding-bottom: 30px;
}
#app .serverisnotavailable-text-title {
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 23px;
  text-align: center;
  padding-bottom: 10px;
}
#app .serverisnotavailable-text{
  display: block;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  line-height: 1.2;
  font-size: 23px;
  text-align: center;
  padding-bottom: 15px;
}
#app .serverisnotavailable-try-recconect-button {
  margin-bottom: 15px;
  border-radius: 15px;
  background: #6070dd;
  font-size: 20px;
}
#app .serverisnotavailable-logout-text{
  display: block;
  font-family: "Lato Light Italic", sans-serif;
  line-height: 1.2;
  font-size: 15px;
  text-align: left;
  padding-top: 20px;
  padding-bottom: 10px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ServerIsNotAvailable.vue?211c311c